export const ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER_BUYER: '/auth/register/buyer',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
    ME: '/auth/me',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    CHANGE_PASSWORD: '/auth/change-password',
    INVITATION_PREVIEW: (token: string) =>
      `/auth/business/invitations/${token}/preview`,
    INVITATION_ACCEPT: (token: string) =>
      `/auth/business/invitations/${token}/accept`,
  },
  BUYER: {
    PROFILE: '/buyer/profile',
    PRODUCTS: '/buyer/products',
    PRODUCT_DETAIL: (id: string) => `/buyer/products/${id}`,
    CART: '/buyer/cart',
    CART_ITEM: (productId: string) => `/buyer/cart/items/${productId}`,
    CART_VALIDATE: '/buyer/cart/validate',
    ORDERS: '/buyer/orders',
    ORDER_DETAIL: (id: string) => `/buyer/orders/${id}`,
    ORDER_PAY: (id: string) => `/buyer/orders/${id}/pay`,
    ORDER_SIMULATE_PAY_FAILED: (id: string) =>
      `/buyer/orders/${id}/simulate-pay-failed`,
    ORDER_CANCEL: (id: string) => `/buyer/orders/${id}/cancel`,
    ORDER_CONFIRM_RECEIVED: (id: string) =>
      `/buyer/orders/${id}/confirm-received`,
    ORDER_REORDER: (id: string) => `/buyer/orders/${id}/reorder`,
    PAYMENTS: '/buyer/payments',
    PAYMENT_DETAIL: (id: string) => `/buyer/payments/${id}`,
    INVOICE: (orderId: string) => `/buyer/orders/${orderId}/invoice`,
    INVOICE_PDF: (orderId: string) => `/buyer/orders/${orderId}/invoice/pdf`,
    ORDER_RESEND_RECEIPT: (id: string) => `/buyer/orders/${id}/resend-receipt`,
    PUSH_TOKENS: '/buyer/me/push-tokens',
  },
  BUSINESS: {
    GET: '/buyer/business',
    CREATE: '/buyer/business/create',
    UPDATE: '/buyer/business',
    MEMBERS: '/buyer/business/members',
    REMOVE_MEMBER: (userId: string) =>
      `/buyer/business/members/${userId}/remove`,
    INVITATIONS: '/buyer/business/invitations',
    REVOKE_INVITATION: (id: string) =>
      `/buyer/business/invitations/${id}/revoke`,
    LEAVE: '/buyer/business/leave',
  },
  NOTIFICATIONS: {
    LIST: '/notifications',
    UNREAD_COUNT: '/notifications/unread-count',
    READ: (id: string) => `/notifications/${id}/read`,
    MARK_ALL_READ: '/notifications/mark-all-read',
  },
  PUBLIC: {
    ORDER_QUERY: '/public/orders/query',
    ORDERS: '/public/orders',
    ORDER_LOOKUP: '/public/orders/lookup',
    ORDER_PAY: (publicOrderNo: string) => `/public/orders/${publicOrderNo}/pay`,
    ORDER_CANCEL: (publicOrderNo: string) => `/public/orders/${publicOrderNo}/cancel`,
    PRODUCTS: '/public/products',
    PRODUCT_DETAIL: (id: string) => `/public/products/${id}`,
    PRODUCT_FACETS: '/public/products/facets',
    SUPPLIERS: '/public/suppliers',
    SUPPLIER_DETAIL: (slug: string) => `/public/suppliers/${slug}`,
    SUPPLIER_PRODUCTS: (slug: string) => `/public/suppliers/${slug}/products`,
  },
} as const;
